<template>
<div class="tw-text-sm font-normal">
  <span>$</span>
  {{storeAnswer.data.value_builder}}
</div>
</template>
<script>
import mixin from './_mixin_display'
export default { mixins: [mixin] }
</script>